import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createTransform } from 'redux-persist';
import CryptoJS from 'crypto-js';
import usuarioSlice from '../features/usuario/usuarioSlice';
import modulosSlice from '../features/modulos/modulosSlice';
import clienteSlice from '../features/cliente/clienteSlice';
import funcionarioSlice from '../features/funcionario/funcionarioSlice';
import tabelaPrecoSlice from '../features/tabelaPreco/tabelaPreco';
import empresaSlice from '../features/empresa/empresaSlice';
import tokenSlice from '../features/token/tokenSlice';
import materialSlice from '../features/material/materialSlice';
import itemSlice from '../features/item/item';
import movimentoSlice from '../features/movimento/movimentoSlice';
import clearReduxStorageMiddleware from './cleanStore';
import authSlice from '../features/auth/logoutSlice';
import logUsuario from '../features/log/logSlice';
import filialSlice from '../features/filial/filialSlice';

const chaveSecreta = process.env.REACT_APP_ENCRYPTION_KEY;

const encrypt = (inboundState) => {
  const stateString = JSON.stringify(inboundState);
  return CryptoJS.AES.encrypt(stateString, chaveSecreta).toString();
};

const decrypt = (outboundState) => {
  const bytes = CryptoJS.AES.decrypt(outboundState, chaveSecreta);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

const cryptoTransform = createTransform(
  (inboundState) => encrypt(inboundState),
  (outboundState) => decrypt(outboundState)
);

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  transforms: [cryptoTransform], 
};

const appReducer = combineReducers({
  token: tokenSlice,
  usuario: usuarioSlice,
  modulo: modulosSlice,
  cliente: clienteSlice,
  funcionario: funcionarioSlice,
  tabelaPreco: tabelaPrecoSlice,
  empresa: empresaSlice,
  material: materialSlice,
  item: itemSlice,
  movimento: movimentoSlice,
  auth: authSlice,
  log: logUsuario,
  filial: filialSlice
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_REDUX_STATE') {
    state = undefined;
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(clearReduxStorageMiddleware.middleware),
});

export const persistor = persistStore(store);
export default store;
